import { ChevronLeft, ChevronRight } from "lucide-react";
import { useScheduleEditor } from "../ScheduleEditorProvider";
import { useGridDrag } from "../hooks/useGridDrag";
import { DAYS, COLORS } from "../constants";
import TimeColumn from "./TimeColumn";
import DayColumn from "./DayColumn";

export default () => {
  const { schedules, selectSchedule, updateSchedule, weekStart, weekLabel, goToNextWeek, goToPrevWeek, goToToday } =
    useScheduleEditor();

  const { gridRef, isDragging, startResize, startDrag } = useGridDrag({
    schedules,
    onScheduleUpdate: updateSchedule,
    onSelect: selectSchedule,
  });

  return (
    <div className="flex flex-col min-w-0 shrink-0" style={{ backgroundColor: COLORS.navyDark }}>
      {/* Header with week navigation */}
      <div className="px-6 py-4 flex items-center justify-between border-b border-zinc-800">
        <div>
          <h1 className="text-2xl font-bold text-white">Schedules</h1>
          <p className="text-sm text-zinc-400 mt-1">Drag edges to resize • Drag blocks to move • Click to edit</p>
        </div>

        {/* Week navigation */}
        <div className="flex items-center gap-2">
          <button
            onClick={goToPrevWeek}
            className="p-1.5 rounded hover:bg-zinc-800 transition-colors text-zinc-400 hover:text-white"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>

          <button
            onClick={goToToday}
            className="px-3 py-1.5 rounded text-sm hover:bg-zinc-800 transition-colors text-zinc-400 hover:text-white"
          >
            Today
          </button>

          <span className="text-white text-sm font-medium min-w-[180px] text-center">{weekLabel}</span>

          <button
            onClick={goToNextWeek}
            className="p-1.5 rounded hover:bg-zinc-800 transition-colors text-zinc-400 hover:text-white"
          >
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>
      </div>

      {/* Time header row */}
      <TimeColumn />

      {/* Day rows - click empty space to deselect */}
      <div ref={gridRef} className="flex flex-col" onClick={() => selectSchedule(null)}>
        {DAYS.map((day, index) => (
          <DayColumn
            key={day.key}
            day={day}
            dayIndex={index}
            isDragging={isDragging}
            onStartResize={startResize}
            onStartDrag={startDrag}
          />
        ))}
      </div>
    </div>
  );
};
